const Utils = require('./cubeInternalUtils');

let fetchImpl,
	formDataImpl,
	XMPPClient,
	XMPPWebSocketTransport;

let RTCPeerConnection,
	RTCSessionDescription,
	RTCIceCandidate,
	MediaStream,
	mediaDevices,
	SDPTransform;

if (Utils.getEnv().browser) {
	fetchImpl = fetch;
	formDataImpl = FormData;
	Strophe = require('strophe.js');
	Object.assign(window, Strophe);
	XMPPClient = require('./cubeStrophe');

	RTCPeerConnection = window.RTCPeerConnection;
	RTCSessionDescription = window.RTCSessionDescription;
	RTCIceCandidate = window.RTCIceCandidate;
	MediaStream = window.MediaStream;
	mediaDevices = navigator.mediaDevices;
	SDPTransform = require('sdp-transform');
} else if (Utils.getEnv().nativescript) {
	fetchImpl = fetch;
	formDataImpl = FormData;
	XMPPClient = require('nativescript-xmpp-client');
} else if (Utils.getEnv().node) {
	fetchImpl = require('node-fetch');
	formDataImpl = require('form-data');
	XMPPClient = require('node-xmpp-client');
}

module.exports = {
	fetchImpl: fetchImpl,
	formDataImpl: formDataImpl,
	XMPPClient: XMPPClient,
	XMPPWebSocketTransport: XMPPWebSocketTransport,
	RTCPeerConnection: RTCPeerConnection,
	RTCSessionDescription: RTCSessionDescription,
	RTCIceCandidate: RTCIceCandidate,
	MediaStream: MediaStream,
	mediaDevices: mediaDevices,
	SDPTransform: SDPTransform
};
